import React, {useContext, useEffect, useState} from 'react';
import './Mission.scss'
import {MqttClientContext} from "../../context/MqttClientContext";
import {UserInfoContext} from "../../context/UserInfoContext";
import mqttRequests from "../../Utils/mqttRequests";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import {Alert, Dialog, DialogActions, DialogTitle, IconButton, Snackbar} from "@mui/material";
import * as Yup from "yup";
import {Form, Formik} from "formik";
import FormikControl from "../FormTemplate/FormikControl";
import {red} from "@mui/material/colors";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {SettingsContext} from "../../context/SettingsContext";
import Loading from '../../assets/Loading.png';
import Cookies from 'universal-cookie';
import missionsPicto from "../../assets/missionPicto.gif";
import Accordion from "react-bootstrap/Accordion";
import visible from "../../assets/visible.png";

//the page to manage missions
function ManageMissions(props) {

    const cookies = new Cookies(null, {path: '/'});

    const setMenuClicked = props.setMenuClicked;
    setMenuClicked('missions');

    //to navigate through the app
    let navigate = useNavigate();

    //back button effect
    useEffect(() => {
        window.addEventListener('popstate', () => {
            navigate("/missions");
        }, false);
    }, [navigate]);

    //the idUser and idAccount for mqtt
    const {idUser, idAccount} = useContext(UserInfoContext);

    //the mqtt client and source
    const {mqttClient, source} = useContext(MqttClientContext);

    //the temperature unit
    const {temperatureUnit} = useContext(SettingsContext);

    //the mission to manage
    const idMission = cookies.get("missionManagement");
    //the previous mission
    const [previousMission, setPreviousMission] = useState([]);

    //variables to set the mission, groupMissions, the groupDeviceMissions and the KineticsMissions, missionSupervision
    const [mission, setMission] = useState([])
    const [groupMission, setGroupMission] = useState([]);
    const [groupDeviceMission, setGroupDeviceMission] = useState([]);
    const [kineticsMission, setKineticsMission] = useState([]);
    const [missionSupervisions, setMissionSupervisions] = useState([]);
    const [calcKinetics, setCalcKinetics] = useState([]);

    //variable to get the groupUsers, the groupDevices and the kinetics, groupNotification, dataType
    const [groupUsers, setGroupUsers] = useState([]);
    const [groupUsersSelect, setGroupUsersSelect] = useState([]);
    const [groupDevice, setGroupDevice] = useState([]);
    const [devices, setDevices] = useState([]);
    const [devicesSelect, setDevicesSelect] = useState([]);
    const [groupDeviceSelect, setGroupDeviceSelect] = useState([]);
    const [kinetics, setKinetics] = useState([]);
    const [kineticsSelect, setKineticsSelect] = useState([]);
    const [groupNotification, setGroupNotification] = useState([]);
    const [dataType, setDataType] = useState([]);

    //variable to open popups
    const [startSuccessOpen, setStartSuccessOpen] = useState(false);
    const [errorNoDeviceOpen, setErrorNoDeviceOpen] = useState(false);
    const [errorTwoOpen, setErrorTwoOpen] = useState(false);
    const [allGroupInMissionError, setAllGroupInMissionError] = useState(false);
    const [allKineticsInMissionError, setAllKineticsInMissionError] = useState(false);
    const [addSupervisionOpen, setAddSupervisionOpen] = useState(false);
    const [groupNotificationDontExistError, setGroupNotificationDontExistError] = useState(false);
    const [noDeviceInMissionError, setNoDeviceInMissionError] = useState(false);
    //message to display popup
    const [messagePopupDialog, setMessagePopupDialog] = useState("");

    //variable to open the dialogs
    const [dialogOpen, setDialogOpen] = useState(false);
    const [addGroupOpen, setAddGroupOpen] = useState(false);
    const [addDeviceOpen, setAddDeviceOpen] = useState(false);
    const [addKineticOpen, setAddKineticOpen] = useState(false);

    //value for the state of the radiobutton
    const [deviceChoiceRadio, setDeviceChoiceRadio] = useState("device");

    const [loadingOn, setLoadingOn] = useState(true);

    //variable to show again the data after a deletion
    const [reshow, setReshow] = useState(false);

    //the initial values for formik to add groupMission
    const addGroupMissionInitialValues = {
        groupUser: "",
        typeAuthorization: 1,
    };

    //the yup validation schema to add groupMission
    const addGroupMissionValidationSchema = Yup.object({
        groupUser: Yup.string().required("Required")
    });

    //values for the select type authorization
    const selectTypeAuthorization = [
        {key: "Read + write", value: 1},
        {key: "Read", value: 2}
    ]

    //initial values for formik to add groupDeviceMission
    const addGroupDeviceMissionInitialValues = {
        idGroupDevice: "",
        idDevice: "",
        idProfile: "",
        dialogRadioValue: "device",
    }

    //the yup validation schema to add groupDeviceMission
    const addGroupDeviceMissionValidationSchema = Yup.object({
        dialogRadioValue: Yup.string(),
        idGroupDevice: Yup.string().when("dialogRadioValue", {
            is: "groupDevice",
            then: () => Yup.string().required("Required"),
            otherwise: () => Yup.string().notRequired(),
        }),
        idDevice: Yup.string().when("dialogRadioValue", {
            is: "device",
            then: () => Yup.string().required("Required"),
            otherwise: () => Yup.string().notRequired(),
        }),
        idProfile: Yup.string().when("dialogRadioValue", {
            is: "profile",
            then: () => Yup.string().required("Required"),
            otherwise: () => Yup.string().notRequired(),
        }),
    });

    //initial values for formik to add kinetics
    const addKineticInitialValues = {
        kinetic: "",
        description: "",
        alphaAeging1: 0,
    };

    //yup validation schema to add kinetics
    const addKineticValidationSchema = Yup.object({
        kinetic: Yup.number().required("Required"),
        alphaAeging1: Yup.number().min(0, "Min : 0").max(0.9999999999999, "Max: 1 (not include)").required("Required"),
    });

    //the 3 options that you can add in the device part
    const dialogRadioOptions = [
        {key: "Device", value: "device"},
        {key: "Group device", value: "groupDevice"},
    ];

    //display popup if missionSupervision is added
    //select which groups to display in the select group users
    useEffect(() => {
        if(cookies.get("missionSupervisionAdded") === "true"){
            setAddSupervisionOpen(true);
            cookies.set("missionSupervisionAdded", "false");
        }
    },[]);

    //method to get all things needed from mqtt
    useEffect(() => {
        if(source !==null){

            //read incoming message and set the mission variable
            mqttRequests.incomingMessage((message) => {
                let jsonParsed = JSON.parse(message.toString());

                //if it's a response for getMission
                if(jsonParsed.mission && jsonParsed.result === 1){
                    jsonParsed.mission.forEach((element) => {
                        //select the last mission
                        if(element.idMission === mission.previousMission){
                            setPreviousMission(element);
                        }
                        //select the actual mission
                        if(element.idMission === idMission){
                            setMission(element);
                        }
                    })
                //if it's a response for getGroupMission
                }else if (jsonParsed.groupMission && jsonParsed.result === 1){
                    setGroupMission(jsonParsed.groupMission);
                //if it's a response for getGroupDeviceMission
                }else if (jsonParsed.groupDeviceMission && jsonParsed.result === 1){
                    setGroupDeviceMission(jsonParsed.groupDeviceMission);
                //if it's a response for getKineticsMission
                }else if (jsonParsed.kineticsMission && jsonParsed.result === 1){
                    setKineticsMission(jsonParsed.kineticsMission);
                //if it's a response for getCalcKineticsMissions
                }else if (jsonParsed.kineticsMissions && jsonParsed.result === 1){
                    setCalcKinetics(jsonParsed.kineticsMissions);
                    setLoadingOn(false);
                //if it's a response for getUserGroup
                }else if(jsonParsed.UserGroupName){
                    if(jsonParsed.result===1){
                        refactorDataUserGroup(jsonParsed);
                    }
                //if it's a response for get devices
                }else if(jsonParsed.devices) {
                    setDevices(jsonParsed.devices);
                //if it's a response for get groupDevice
                }else if(jsonParsed.deviceGroupName){
                    if(jsonParsed.result===1){
                        refactorDataDeviceGroup(jsonParsed);
                    }
                //if it's a response for getKinetics
                }else if(jsonParsed.kinetics){
                    setKinetics(jsonParsed.kinetics);
                //if it's a response for an add or delete
                }else if (jsonParsed.missionSupervision) {
                    setMissionSupervisions(jsonParsed.missionSupervision);
                } else if(jsonParsed.groupNotification){
                    setGroupNotification(jsonParsed.groupNotification);
                }else if (jsonParsed.idDataType){
                    refactorDataType(jsonParsed);
                }else if (jsonParsed.result === 1){
                    setStartSuccessOpen(true);
                    setReshow(!reshow);
                }else if (jsonParsed.result === -2){
                    setErrorTwoOpen(true);
                }
            });

            //demand to get a mission
            //generate operation code
            let operation = mqttRequests.generateOperationCode("getMissions");

            //create json to publish
            let data = '{"operation":"' + operation + '", "source":"' + source + '", "idUser":"' + idUser + '"}';
            //subscribe to the channel to wait for the mqtt response
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getMissions");
            //publish a demand to get all the missions
            mqttRequests.publish(mqttClient, "mission/getMissions", data);

            //demand to get groupMission
            operation = mqttRequests.generateOperationCode("getGroupMissions");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + idMission + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupMissions");
            mqttRequests.publish(mqttClient, "mission/getGroupMissions", data);

            //demand to get groupDeviceMission
            operation = mqttRequests.generateOperationCode("getGroupDeviceMissions");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + idMission + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupDeviceMissions");
            mqttRequests.publish(mqttClient, "mission/getGroupDeviceMissions", data);

            //demand to get kineticsMission
            operation = mqttRequests.generateOperationCode("getKineticsMissions");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + idMission + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getKineticsMissions");
            mqttRequests.publish(mqttClient, "mission/getKineticsMissions", data);

            //demand to get the groupUsers
            operation = mqttRequests.generateOperationCode("getGroupUser");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupUser");
            mqttRequests.publish(mqttClient, "user/getGroupUser", data);

            //demand to get the groupDevices
            operation = mqttRequests.generateOperationCode("getGroupDevice");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupDevice");
            mqttRequests.publish(mqttClient, "device/getGroupDevice", data);

            //demand to get the devices
            operation = mqttRequests.generateOperationCode("getAllDevices");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getAllDevices");
            mqttRequests.publish(mqttClient, "device/getAllDevices", data);

            //demand to get the kinetics
            operation = mqttRequests.generateOperationCode("getKinetic");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getKinetic");
            mqttRequests.publish(mqttClient, "kinetic/getKinetic", data);

            //demand to get mission supervisions
            operation = mqttRequests.generateOperationCode("getMissionSupervisions");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + idMission + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getMissionSupervisions");
            mqttRequests.publish(mqttClient, "alarm/getMissionSupervisions", data);

            //demand to get groupNotifications
            operation = mqttRequests.generateOperationCode("getGroupNotification");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getGroupNotification");
            mqttRequests.publish(mqttClient, "alarm/getGroupNotification", data);

            //demand to get datatypes
            operation = mqttRequests.generateOperationCode("getDataType");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getDataType");
            mqttRequests.publish(mqttClient, "device/getDataType", data);

            //ask for kinetics results
            operation = mqttRequests.generateOperationCode("getCalcKineticsMissions");
            data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + idMission + '"}';
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getCalcKineticsMissions");
            mqttRequests.publish(mqttClient, "mission/getCalcKineticsMissions", data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[source, idUser, mqttClient, reshow]);

    //select which groups to display in the select group users
    useEffect(() => {
        let tempGroupUsers = [];
        if(groupUsers.length!==0){
            tempGroupUsers = groupUsers.map((element) => {
                //if the group is visible and don't have rights yet
                if(element.hide===0 && !checkUserGroupHasRights(element.id)){
                    return {
                        key: element.name,
                        value: element.id,
                    }
                }
                return undefined;
            });
        }
        let tempObject = [{key: "Select", value: ""}]
        setGroupUsersSelect([...tempObject, ...tempGroupUsers.filter(element => element !== undefined)]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[groupUsers]);

    //select which device to display in the selected device
    useEffect(() => {
        let tempDevices = [];
        if(devices.length!==0){
            tempDevices = devices.map((element) => {
                //if the group is not in the mission
                if(!checkDeviceIsIn(element.idDevice)){
                    return {
                        key: element.identifier,
                        value: element.idDevice,
                    }
                }
                return undefined;
            });
        }
        setDevicesSelect(tempDevices.filter(element => element !== undefined));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[devices]);

    //select which group device to display in the selected device
    useEffect(() => {
        let tempGroupDevices = [];
        if(groupDevice.length!==0){

            tempGroupDevices = groupDevice.map((element) => {
                return {
                    key: element.name,
                    value: element.id,
                }
            });

        }
        let tempObject = [{key: "Select", value: ""}]
        setGroupDeviceSelect([...tempObject, ...tempGroupDevices]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[groupDevice]);

    //select which kinetics to display in the select kinetics
    useEffect(() => {
        let tempKinetics = [];
        if(kinetics.length!==0){
            tempKinetics = kinetics.map((element) => {
                //if the kinetic is not in the group and is visible
                if(element.hideKinetics===0 && !checkKineticsInMission(element.idKinetics)){
                    return {
                        key: element.nameKinetics,
                        value: element.idKinetics,
                    }
                }
                return undefined;
            });
        }
        let tempObject = [{key: "Select", value: ""}]
        setKineticsSelect([...tempObject, ...tempKinetics.filter(element => element !== undefined)]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[kinetics]);

    //function which return true if the user group has already rights in the mission
    const checkUserGroupHasRights = (id) => {
        let result = false;
        if(groupMission.length !==0){
            groupMission.forEach((element) => {
                if(element.idGroupUser === id){
                    result = true;
                }
            })
        }
        return result;
    }

    //function which return true if the device is already in the mission
    const checkDeviceIsIn = (id) => {
        let result = false;
        if(groupDeviceMission.length !==0){
            groupDeviceMission.forEach((element) => {
                if(element.idDevice === id){
                    result = true;
                }
            })
        }
        return result;
    }

    //function which returns true if the kinetic is already in the mission
    const checkKineticsInMission = (id) => {
        let result = false;
        if(kineticsMission.length !== 0){
            kineticsMission.forEach((element) => {
                if(element.idKinetics === id){
                    result = true;
                }
            })
        }
        return result;
    }

    //refactor data to set a variable with the group user
    const refactorDataUserGroup = (data) => {
        //store all the GroupUsers in a variable
        setGroupUsers(data.idGroupUser.map((id, index_value) =>{
            return {
                name: data.UserGroupName[index_value],
                id: id,
                hide: data.UserGroupHide[index_value],
            }
        }));
    }

    //refactor data to set a variable with the group device
    const refactorDataDeviceGroup = (data) => {
        //store all the groupDevices in a variable
        let tempGroupDevice = data.idGroupDevice.map((id, index_value) =>{
            if(data.deviceGroupHide[index_value] === 0){
                return {
                    name: data.deviceGroupName[index_value],
                    id: id,
                    hide: data.deviceGroupHide[index_value],
                }
            }
            return undefined;

        });
        setGroupDevice(tempGroupDevice.filter(element => element !== undefined));
    }

    //refactor datatype to set it in a variable
    const refactorDataType = (data) => {
        setDataType(data.idDataType.map((idDataType, index) =>{
            return {
                id: idDataType,
                name : data.description[index]
            }
        }))
    }

    //display the correct status (the status 4 is not displayed)
    const displayState = (state) => {
        if(state === 1){
            return "Planned";
        }
        if(state === 2){
            return "in progress";
        }
        if(state === 3){
            return "finished";
        }
        return "archived";
    }

    //open the dialog "are you sure to act with the mission" with the correct word to start stop or archive the mission
    const manageDialog = (state) => {
        if(groupDeviceMission.length !== 0){
            switch (state){
                case 1:
                    setMessagePopupDialog("start");
                    break;
                case 2:
                    setMessagePopupDialog("stop");
                    break;
                case 3:
                    setMessagePopupDialog("archive");
                    break;
                default:
                    break;
            }
            setDialogOpen(true);
        }else
            setErrorNoDeviceOpen(true);
    }

    //the method to really change state of the mission
    const manageStateMission = () => {

        //close the dialog
        setDialogOpen(false);

        //set the state of the mission and prepare the success popup
        let newState = 2;
        switch (messagePopupDialog){
            case "start":
                setMessagePopupDialog("Mission successfully started");
                break;
            case "stop":
                setMessagePopupDialog("Mission successfully stopped");
                newState = 3;
                break;
            case "archive":
                setMessagePopupDialog("Mission successfully archived");
                newState = 4;
                break;
            default:
                break;
        }

        //set and adjust the start and stop date
        let startDate = mission.dateStart;
        let stopDate = mission.dateStop;

        let lastCheck = 0;

        //if the mission start now, set the start date and the last check at now
        if(mission.stateMission === 1){
            startDate = Math.round(new Date().getTime()/1000);
            lastCheck = startDate;
        }
        //if the mission finish now, set the stop date at now
        if(mission.stateMission === 2){
            stopDate = Math.round(new Date().getTime()/1000);
        }

        //modify in the db
        //generate operation code
        const operation = mqttRequests.generateOperationCode("editMission");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '", "idMission":"'
            + mission.idMission + '", "oldNameMission":"' + mission.nameMission + '", "newNameMission":"' + mission.nameMission + '", "descrMission":"' + mission.descrMission
            + '", "dateStart":"' + startDate + '", "dateStop":"' + stopDate + '", "stateMission":"' + newState + '", "lastCheck":"' + lastCheck + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/editMission");
        //publish a demand to edit the mission
        mqttRequests.publish(mqttClient, "mission/editMission", data);
    }

    //function to add a groupMission to the mission
    const addGroupMission = (value) => {
        //close the dialog
        setAddGroupOpen(false);

        //generate operation code
        const operation = mqttRequests.generateOperationCode("addGroupMission");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idGroupUser":"' + value.groupUser + '", "idMission":"'
            + mission.idMission + '", "typeAuthorization":"' + value.typeAuthorization + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/addGroupMission");
        //publish a demand to edit the mission
        mqttRequests.publish(mqttClient, "mission/addGroupMission", data);

        //display the success popup and reshow data
        setMessagePopupDialog("Right successfully added");
        setReshow(!reshow);
    }

    //function to send the name depending on the id to display
    const displayGroupUserName = (id) => {
        let nameToDisplay = "";
        groupUsers.forEach((element) => {
            if(element.id === id){
                nameToDisplay = element.name;
            }
        });
        return nameToDisplay;
    }

    //function to send the name depending on the id to display
    const displayKineticsName = (id) => {
        let nameToDisplay = "";
        kinetics.forEach((element) => {
            if(element.idKinetics === id){
                nameToDisplay = element.nameKinetics;
            }
        });
        return nameToDisplay;
    }

    //manage to open the dialog to add group users or display the warning popup
    const manageOpenAddGroup = () => {
        if(groupUsersSelect.length !== 1){
            setAddGroupOpen(true);
        }else {
            setAllGroupInMissionError(true);
        }
    }

    //really delete groupMission
    const handleDeleteGroup = (idGroupUser) => {
        //generate operation code
        const operation = mqttRequests.generateOperationCode("deleteGroupMission");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idGroupUser":"' + idGroupUser + '", "idMission":"' +
            idMission + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/deleteGroupMission");
        //publish a demand to add a user
        mqttRequests.publish(mqttClient, "mission/deleteGroupMission", data);

        //rerender data, if not, we don't see the deletion
        setReshow(!reshow);
        //set the message for the popup
        setMessagePopupDialog("Right successfully removed from the mission");
    }

    //manage the cancel button for the dialogs
    const handleCancelAddGroupDevice = () => {
        setDeviceChoiceRadio("device");
        setAddDeviceOpen(false);
    }

    //function to add group device in the mission
    const addGroupDeviceMission = (value) => {
        //close the dialog
        setAddDeviceOpen(false);

        //generate operation code
        const operation = mqttRequests.generateOperationCode("addGroupDeviceMission");

        //prepare the data
        let idGroupDevice = null;
        let idDevice = null;
        let idProfile = null;

        switch (deviceChoiceRadio){
            case "groupDevice":
                idGroupDevice = value.idGroupDevice;
                break;
            case "device":
                idDevice = value.idDevice;
                break;
            default:
                break;
        }

        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idMission":"' + mission.idMission
            + '", "idGroupDevice":"' + idGroupDevice + '", "idDevice":"' + idDevice + '", "idProfile":"' + idProfile
            + '", "startdate":"' + 0 + '", "stopdate":"' + 0 + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/addGroupDeviceMission");
        //publish a demand to edit the mission
        mqttRequests.publish(mqttClient, "mission/addGroupDeviceMission", data);

        //prepare the popup
        setMessagePopupDialog(deviceChoiceRadio + " successfully added");
        //reset the form
        setDeviceChoiceRadio("device");
        //reshow the data
        setReshow(!reshow);
    }

    //really delete the groupDevices
    const handleDeleteGroupDevice = (id) => {
        //generate operation code
        const operation = mqttRequests.generateOperationCode("deleteGroupDeviceMission");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idDeviceMission":"' + id + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/deleteGroupDeviceMission");
        //publish a demand to add a user
        mqttRequests.publish(mqttClient, "mission/deleteGroupDeviceMission", data);

        //rerender data, if not, we don't see the deletion
        setReshow(!reshow);
        //set the message for the popup
        setMessagePopupDialog("Device successfully removed from the mission");
    }

    //go to the page "view kinetics"
    const NavigateViewKinetics = (device) => {
        if(typeof(device) === "string"){
            devices.forEach((element) => {
                if(element.identifier === device){
                    device = element;
                }
            })
        }
        cookies.set("KinCalcDevice", device);
        cookies.set("MissionFirstPointTime", mission.dateStart.toString());
        navigate("/kineticsData");
    }

    //display the name and the identifier of the device based on the id
    const displayDeviceName = (idDeviceToDisplay) => {
        let deviceToDisplay = {};
        devices.forEach((element) => {
            if (element.idDevice === idDeviceToDisplay) {
                deviceToDisplay = element;
            }
        });
        return (
            <h4 className="missionText">{deviceToDisplay.customName}</h4>
        )
    }

    const displayDeviceAddress = (idDeviceToDisplay) => {
        let deviceToDisplay = {};
        devices.forEach((element) => {
            if (element.idDevice === idDeviceToDisplay) {
                deviceToDisplay = element;
            }
        });
        return (
            <p className="missionText">{deviceToDisplay.identifier}</p>
        )
    }
    const displayDeviceActions = (idDeviceToDisplay) => {
        let deviceToDisplay = {};
        devices.forEach((element) => {
            if (element.idDevice === idDeviceToDisplay) {
                deviceToDisplay = element;
            }
        });
        return (
            <>
                <button className="missionButton" onClick={() => NavigateViewData(deviceToDisplay)} style={{"margin-right" : "5px", "margin-top" : "2px"}}>View data</button>
                {calcKinetics.length !== 0 && mission.stateMission !== 1 ?
                    displayViewKinetics(deviceToDisplay.identifier) ?
                        <button className="missionButton" onClick={() => NavigateViewKinetics(deviceToDisplay)}>View kinetics</button>
                        :
                        null
                    :
                    loadingOn ?
                        <img src={Loading} className="missionimgLoading" style={{ userSelect: "none" }} alt="Loading"/>
                        :
                        null
                }
            </>
        )
    }

    //return true if some regression stats are available for the device
    const displayViewKinetics = (id) => {
        let response = false;
        calcKinetics[0].device.forEach((element) => {
            if(element !== null){
                if(element.time.length !== 0 && (element.identifier.substring(0,15) === id || element.identifier.substring(16) === id)){
                    response = true;
                }
            }

        })
        return response ;
    }

    //go to device view data page
    const NavigateViewData = (device) => {

        if(typeof(device) === "string"){
            devices.forEach((element) => {
                if(element.identifier === device){
                    device = element;
                }
            })
        }
        cookies.set("device", device);
        if(mission.stateMission === 2){
            cookies.set("startDate", moment(new Date(mission.dateStart*1000)).format('YYYY-MM-DD'));
        }else {
            cookies.set("startDate", moment(new Date(device.lastPoint * 1000)).format('YYYY-MM-DD'));
        }
        cookies.set("endDate", moment(new Date(device.lastPoint * 1000)).format('YYYY-MM-DD'));
        navigate("/deviceData");
    }

    //send the name of the device from the id
    const displayNameDevice = (id) => {
        let name = "";
        devices.forEach((element) => {
            if(element.idDevice === id){
                name = element.customName + ' (' + element.identifier + ')';
            }
        })
        return name;
    }

    //sent the name of the device from the identifier
    const displayNameDeviceFromIdentifier = (id) => {
        let name = "";
        devices.forEach((element) => {
            if(element.identifier === id){
                name = element.customName + ' (' + element.identifier + ')';
            }
        })
        return name;
    }

    //open the dialog to add kinetics or display the warning popup if all kinetics are in the mission
    const manageOpenAddKinetic = () => {
        if(kineticsSelect.length !== 1){
            setAddKineticOpen(true);
        }else {
            setAllKineticsInMissionError(true);
        }
    }

    //function to really add kinetics in the missions
    const addKineticMission = (value) => {
        //close the dialog
        setAddKineticOpen(false);

        //generate operation code
        const operation = mqttRequests.generateOperationCode("addKineticsMission");


        //manage the alphaaeging
        let alphaaeging1 = 0.0000000001;

        if(value.alphaAeging1 !== 0) {
            alphaaeging1 = value.alphaAeging1;
        }

        //create the json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idKinetics":"' + value.kinetic
            + '", "idMission":"' + mission.idMission + '", "descrKineticsMission":"' + value.description + '", "alphaAeging1":"'
            + alphaaeging1 + '", "startdate":"' + 0 + '", "stopdate":"' + 0 + '", "pathFileKin":""}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/addKineticsMission");

        //publish a demand to edit the mission
        mqttRequests.publish(mqttClient, "mission/addKineticsMission", data);

        //prepare the popup and reshow the data
        setMessagePopupDialog("Kinetic successfully added");
        setReshow(!reshow);
    }

    //really remove a kinetic from a mission
    const handleDeleteKinetics = (id) => {
        //generate operation code
        const operation = mqttRequests.generateOperationCode("deleteKineticsMission");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idKineticsMission":"' + id + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/deleteKineticsMission");
        //publish a demand to add a user
        mqttRequests.publish(mqttClient, "mission/deleteKineticsMission", data);

        //rerender data, if not, we don't see the deletion
        setReshow(!reshow);

        //set the message for the popup
        setMessagePopupDialog("Kinetic successfully removed from the mission");
    }

    //send the user to the addSupervision page
    const handleAddSupervisions = () => {
        if(groupNotification.length === 0){
            setGroupNotificationDontExistError(true);
        }else if(groupDeviceMission.length === 0){
            setNoDeviceInMissionError(true);
        }else{
            cookies.set("groupDeviceMission", groupDeviceMission);
            cookies.set("kineticsMission", kineticsMission);
            cookies.set("idMission", mission.idMission);
            cookies.set("kinetics", JSON.stringify({ ...kinetics }));
            let tempArray = [];
            groupDeviceMission.forEach((element) => {
                devices.forEach((tempDevices) => {
                    if(tempDevices.idDevice === element.idDevice) {
                        let tempArrayElement = {key: tempDevices.customName, value: tempDevices.idDevice};
                        tempArray.push(tempArrayElement);
                    }
                })
            })
            let tempObject = [{key: "Select", value: ""}]
            cookies.set("deviceSelectOptions", [...tempObject, ...tempArray]);

            navigate("/addSupervision");
        }
    }

    //delete the mission supervision selected
    const handleDeleteMissionSupervision = (id) => {
        //generate operation code
        const operation = mqttRequests.generateOperationCode("deleteMissionSupervision");

        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idMissionSupervision":"' + id + '"}';
        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/deleteMissionSupervision");

        //publish a demand to delete a mission supervision
        mqttRequests.publish(mqttClient, "alarm/deleteMissionSupervision", data);

        //rerender data, if not, we don't see the deletion
        setReshow(!reshow);

        //set the message for the popup
        setMessagePopupDialog("Supervision successfully removed from the mission");
    }

    //get the name of the group notification from the id
    const getGroupNotifNameFromId = (id) => {
        let name = "";
        groupNotification.forEach((element) => {
            if(element.idGroupNotification === id){
                name = element.nameGroupNotif;
            }
        })
        return name ;
    }

    //create the text to display after the "when" (the datatype, the limitType and the limit)
    const DefineWhenAlarm = (idDataType, limiteType, limit, gi) => {
        if(idDataType === '20230126103350301008'){
            return "there is a crash"
        }else {
            let name = "";
            dataType.forEach((element) => {
                if(element.id === idDataType){
                    name = element.name;
                }
            })
            if(gi === "external"){
                name = name + " external"
            }else if(gi === "mv"){
                name = name + " mV"
            }else if(gi === "gateway" && idDataType === "20230126103350301001"){
                name = name + " %"
            }
            //display the temperature corresponding to the unit defined in the settings
            if(name === "Temperature" && (limiteType === 1 || limiteType === 2)){
                let limitCorrectUnit = limit;
                if(temperatureUnit === "F"){
                    limitCorrectUnit = Math.round(((limit*9/5)+32) *100)/100;
                }
                if(temperatureUnit === "K"){
                    limitCorrectUnit = Math.round((limit+273.15) *100)/100;
                }

                if(limiteType === 1) {
                    return name + " is larger than " + limitCorrectUnit;
                }else if (limiteType === 2) {
                    return name + " is lower than " + limitCorrectUnit;
                }
            }else{
                if(limiteType === 1) {
                    return name + " is larger than " + limit;
                }else if (limiteType === 2){
                    return name + " is lower than " + limit;
                }else {
                    return "The device don't send points since " + limit + " minutes";
                }
            }
        }
    }

    //activate or deactivate the mission supervision
    const handleModifyMissionSupervision = (supervision) => {
        let active = 1;
        if(supervision.actif === 1){
            active = 2;
        }
        //generate operation code
        const operation = mqttRequests.generateOperationCode("editMissionSupervision");

        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idMissionSupervision":"' + supervision.idMissionSupervision
            + '", "idGroupNotification":"' + supervision.idGroupNotification + '", "actif":"' + active + '"}';
        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/editMissionSupervision");

        //publish a demand to add a user
        mqttRequests.publish(mqttClient, "alarm/editMissionSupervision", data);

        //rerender data, if not, we don't see the deletion
        setReshow(!reshow);

        //set the message for the popup
        setMessagePopupDialog("Supervision successfully edited");
    }

    //transform the key in each device to name(identifier)
    const selectDeviceToSelect = (devicesSelect) => {

        devicesSelect.forEach((device) => {

            let deviceSelected = null;
            devices.forEach((element) => {
                if (element.idDevice === device.value) {
                    deviceSelected = element;
                }
            });
            if(deviceSelected !== null){
                device.key = deviceSelected.customName + ' (' + deviceSelected.identifier + ')';
            }
        }) ;

        //sort the objects
        devicesSelect = devicesSelect.sort((a,b) => (a.key > b.key) ? 1 : -1);

        //add select in start of array
        let tempObject = [{key: "Select", value: ""}]

        return [...tempObject, ...devicesSelect];
    }

    /*      Mission status:
            1 = en préparation
            2 = en cours
            3 = terminé
            4 = archivé */

    return(
        <div className="baseMainDiv">
            <div className="BaseTitleDiv">
                <img src={missionsPicto} alt="Picto" className="basePicto"/>
                <h2 className="baseTitle">MISSION</h2>
            </div>
            <div className="basePageBody"></div>
            <h2 className="DeviceSubTitle">Mission : {mission.nameMission}</h2>
            <table className="MissionTable">
                <tbody>
                    <tr className="baseTr">
                        <td className="missionSpan">Description: </td>
                        <td className="missionTd">{mission.descrMission}</td>
                    </tr>
                    {mission.previousMission !== mission.idMission ?
                        <tr className="baseTr">
                            <td className="missionSpan">Previous Mission: </td>
                            <td className="missionTd">{previousMission.nameMission}</td>
                        </tr>
                        :
                        null
                    }
                    <tr className="baseTr">
                        <td className="missionSpan">Start date: </td>
                        {mission.dateStart !== 0 ?
                            <td className="missionTd">{moment(new Date(mission.dateStart*1000)).format("MMMM DD YYYY")}</td>
                            :
                            <td className="missionTd">Not defined yet</td>
                        }
                    </tr>
                    <tr className="baseTr">
                        <td className="missionSpan">Stop date: </td>
                        {mission.dateStop !== 0 ?
                            <td className="missionTd">{moment(new Date(mission.dateStop*1000)).format("MMMM DD YYYY")}</td>
                            :
                            <td className="missionTd">Not defined yet</td>
                        }
                    </tr>
                    <tr className="baseTr">
                        <td className="missionSpan">State: </td>
                        <td className="missionTd">{displayState(mission.stateMission)}</td>
                        {mission.userRights !==2?
                            mission.stateMission === 1?
                                <button className="missionButtonLeft" onClick={() => manageDialog(mission.stateMission)}>Start Mission</button>
                                :
                                mission.stateMission === 2 ?
                                    <button className="missionButtonLeft" onClick={() => manageDialog(mission.stateMission)}>Stop Mission</button>
                                    :
                                    mission.stateMission === 3 ?
                                        <button className="missionButtonLeft" onClick={() => manageDialog(mission.stateMission)}>Archive Mission</button>
                                        :
                                        null
                            :
                            null
                        }
                    </tr>
                </tbody>
            </table>
            <Accordion alwaysOpen defaultActiveKey={["gu", "devices", "kinetics", "supervision"]}>
                <div className="missionDivText">
                    <Accordion.Item eventKey="gu">
                        <Accordion.Header>
                            <span className="deviceSpan">
                                <img className="deviceVisible" src={visible}/>
                            </span>
                            Group users</Accordion.Header>
                        <Accordion.Body>
                            {mission.userRights !==2?
                                <button onClick={manageOpenAddGroup} className="missionButton">Add group user</button>
                                :
                                null
                            }
                            {groupMission.length!==0?
                                <table className="missionTable">
                                    <thead>
                                        <tr>
                                            <th className="missionTableTh" style={{"min-width":"150px"}}>Group</th>
                                            <th className="missionTableTh" style={{"width":"150px"}}>Rights</th>
                                            {mission.userRights !==2?
                                                <th className="missionTableTh" style={{"width":"80px"}}>Delete</th>
                                                :
                                                null
                                            }
                                        </tr>
                                    </thead>
                                    {groupMission.map(function (group, id) {
                                    return (
                                        <tbody key={id}>
                                        <tr className="alarmDivTxt">
                                            <td className="alarmTableTd">
                                                <h4 className="missionText">{displayGroupUserName(group.idGroupUser)}</h4>
                                            </td>
                                            <td className="alarmTableTd">
                                                <p className="missionText">{group.typeAuthorization===1?"Read + write":"Read only"}</p>
                                            </td>
                                            <td className="alarmTableTd">
                                                <IconButton sx={{ color: red[500], backgroundColor: red[100], borderRadius: '20%', width: 15, height: 15, "&:hover":{backgroundColor: red[100]}}} onClick={() => handleDeleteGroup(group.idGroupUser)}>
                                                    <CloseRoundedIcon sx={{fontSize : 12}}/>
                                                </IconButton>
                                            </td>
                                        </tr>
                                        </tbody>
                                    )})}
                                </table>
                            :
                                <p className="missionMessage">Only you has rights to the mission</p>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                </div>
                <div className="missionDivText">
                    <Accordion.Item eventKey="devices">
                        <Accordion.Header>
                            <span className="deviceSpan">
                                <img className="deviceVisible" src={visible}/>
                            </span>
                            Devices</Accordion.Header>
                        <Accordion.Body>
                    {mission.userRights !==2?
                        <button onClick={() => setAddDeviceOpen(true)} className="missionButton">Add device</button>
                        :
                        null
                    }
                    {groupDeviceMission.length!==0?
                        <table className="missionTable">
                            <thead>
                                <tr>
                                    <th className="missionTableTh" style={{"min-width":"150px"}}>Name</th>
                                    <th className="missionTableTh">Identifier</th>
                                    {mission.userRights !==2?
                                        <th className="missionTableTh">Actions</th>
                                        :
                                        null
                                    }
                                </tr>
                            </thead>
                            {groupDeviceMission.map(function (device, id) {
                                return(
                                    <tbody key={id}>
                                        <tr className="alarmDivTxt">
                                            <td className="alarmTableTd">
                                                {displayDeviceName(device.idDevice)}
                                            </td>
                                            <td className="alarmTableTd">
                                                {displayDeviceAddress(device.idDevice)}
                                            </td>
                                            <td className="alarmTableTd">
                                                {displayDeviceActions(device.idDevice)}
                                                {mission.userRights !== 2 ?
                                                    mission.stateMission === 1 ?
                                                        mission.userRights !==2?
                                                            <IconButton sx={{ color: red[500], backgroundColor: red[100], borderRadius: '20%',
                                                                width: 30, height: 30, "&:hover":{backgroundColor: red[100]}, marginBottom: "2px"}} onClick={() => handleDeleteGroupDevice(device.idDeviceMission)}>
                                                                <CloseRoundedIcon sx={{fontSize : 18}}/>
                                                            </IconButton>
                                                            :
                                                            null
                                                        :
                                                        null

                                                    :
                                                    null
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            })}
                        </table>
                        :
                        <p className="missionMessage">No devices currently added to the mission</p>
                    }
                        </Accordion.Body>
                    </Accordion.Item>
                </div>
                <div className="missionDivText">
                    <Accordion.Item eventKey="kinetics">
                        <Accordion.Header>
                            <span className="deviceSpan">
                                <img className="deviceVisible" src={visible}/>
                            </span>
                            Kinetics</Accordion.Header>
                        <Accordion.Body>
                    {mission.userRights !==2?
                        <button onClick={manageOpenAddKinetic} className="missionButton">Add kinetics</button>
                        :
                        null
                    }
                    {kineticsMission.length!==0?
                        <table className="missionTable">
                            <thead>
                            <tr>
                                <th className="missionTableTh" style={{"min-width":"150px"}}>Name</th>
                                {mission.userRights !==2 && mission.stateMission === 1 ?
                                    <th className="missionTableTh" style={{"width":"80px"}}>Delete</th>
                                    :
                                    null
                                }
                            </tr>
                            </thead>
                            {kineticsMission.map(function (kinetic, id) {
                            return (
                                <tbody key={id}>
                                <tr className="alarmDivTxt">
                                    <td className="alarmTableTd">
                                        <h4 className="missionText">{displayKineticsName(kinetic.idKinetics)}</h4>
                                    </td>
                                    {mission.stateMission === 1 && mission.userRights !== 2 ?
                                        <td className="alarmTableTd">
                                            <IconButton sx={{ color: red[500], backgroundColor: red[100], borderRadius: '20%', width: 15, height: 15, "&:hover":{backgroundColor: red[100]} }} onClick={() => handleDeleteKinetics(kinetic.idKineticsMission)}>
                                                <CloseRoundedIcon sx={{fontSize : 12}}/>
                                            </IconButton>
                                        </td>
                                        :
                                        null
                                    }
                                </tr>
                                </tbody>
                            )
                        })}
                        </table>
                        :
                        <p className="missionMessage">No kinetics are currently assigned to the mission</p>
                    }
                        </Accordion.Body>
                    </Accordion.Item>
                </div>
                <div className="missionDivText">
                    <Accordion.Item eventKey="supervision">
                        <Accordion.Header>
                            <span className="deviceSpan">
                                <img className="deviceVisible" src={visible}/>
                            </span>
                            Supervisions</Accordion.Header>
                        <Accordion.Body>
                    {mission.userRights !==2?
                        <button onClick={handleAddSupervisions} className="missionButton">Add Supervisions</button>
                        :
                        null
                    }
                    {missionSupervisions.length!==0?
                        <table className="missionTable">
                            <thead>
                                <tr>
                                    <th className="missionTableTh">On device</th>
                                    <th className="missionTableTh">Device connected</th>
                                    <th className="missionTableTh">Kinetics</th>
                                    <th className="missionTableTh">Notification</th>
                                    <th className="missionTableTh">Trigger</th>
                                    <th className="missionTableTh">Active</th>
                                    <th className="missionTableTh">Actions</th>
                                </tr>
                            </thead>
                            {missionSupervisions.map(function (supervision, id) {
                            return (
                                <tbody key={id}>
                                <tr className="alarmDivTxt">
                                    <td className="alarmTableTd">
                                        <h4 className="missionText">{displayNameDevice(supervision.idDevice)}</h4>
                                    </td>
                                    <td className="alarmTableTd">
                                        {supervision.gatewayIdentifier === "mv" || supervision.gatewayIdentifier === "external" || supervision.gatewayIdentifier === "gateway"?
                                            <p className="missionText">Gateway</p>
                                            :
                                            supervision.gatewayIdentifier !== ""?
                                                <p className="missionText">{displayNameDeviceFromIdentifier(supervision.gatewayIdentifier)}</p>
                                                :
                                                <p className="missionText">-</p>
                                        }
                                    </td>
                                    <td className="alarmTableTd">
                                        {supervision.idKinetics !== ""?
                                            <p className="missionText">{displayKineticsName(supervision.idKinetics)}</p>
                                            :
                                            <p className="missionText">-</p>
                                        }
                                    </td>
                                    <td className="alarmTableTd">
                                        <p className="missionText">{supervision.severity === 1 ? "warning" : "critical"}, to {getGroupNotifNameFromId(supervision.idGroupNotification)}</p>
                                    </td>
                                    <td className="alarmTableTd">
                                        <p className="missionText">{DefineWhenAlarm(supervision.idDatatype, supervision.limiteType, supervision.limite, supervision.gatewayIdentifier)}</p>
                                    </td>
                                    <td className="alarmTableTd">
                                        <p className="missionText">{supervision.actif === 1 ? "Yes" : <span style={{color:"red"}}>No</span>}</p>
                                    </td>
                                    <td className="alarmTableTd">
                                        {mission.userRights !==2?
                                            supervision.actif === 1?
                                                <button className="missionButton" onClick={() => handleModifyMissionSupervision(supervision)} style={{"margin-right" : "5px", "margin-top" : "2px"}}>Deactivate</button>
                                                :
                                                <button className="missionButton" onClick={() => handleModifyMissionSupervision(supervision)} style={{"margin-right" : "5px", "margin-top" : "2px"}}>Activate</button>
                                            :
                                            null
                                        }
                                        {mission.stateMission === 1 ?
                                            mission.userRights !==2?
                                                <IconButton sx={{ color: red[500], backgroundColor: red[100], borderRadius: '20%', width: 30, height: 30,
                                                    "&:hover":{backgroundColor: red[100]}, marginBottom: "2px" }} onClick={() => handleDeleteMissionSupervision(supervision.idMissionSupervision)}>
                                                    <CloseRoundedIcon/>
                                                </IconButton>
                                                :
                                                null
                                            :
                                            null
                                        }
                                        {mission.userRights === 2 ?
                                            <p className="missionText">-</p>
                                            :
                                            null
                                        }
                                    </td>
                                </tr>
                                </tbody>
                            )})}
                        </table>
                        :
                        <p className="missionMessage">No supervision currently assigned to the mission</p>
                    }
                        </Accordion.Body>
                    </Accordion.Item>
                </div>
            </Accordion>

            <div className="missionBackButtonDiv">
                <button onClick={() => navigate("/missions")} className="missionBackButton">Back</button>
            </div>
            <Snackbar open={startSuccessOpen} autoHideDuration={4000} onClose={() => setStartSuccessOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="success">{messagePopupDialog}</Alert>
            </Snackbar>
            <Snackbar open={errorNoDeviceOpen} autoHideDuration={5000} onClose={() => setErrorNoDeviceOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="error">Error - Assign at least one device to this mission to start it</Alert>
            </Snackbar>
            <Snackbar open={errorTwoOpen} autoHideDuration={4000} onClose={() => setErrorTwoOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="error">Error - Something went wrong, try again later</Alert>
            </Snackbar>
            <Snackbar open={allGroupInMissionError} autoHideDuration={4000} onClose={() => setAllGroupInMissionError(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="warning">All groups already have rights for this mission</Alert>
            </Snackbar>
            <Snackbar open={allKineticsInMissionError} autoHideDuration={4000} onClose={() => setAllKineticsInMissionError(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="warning">All kinetics already assigned to this mission</Alert>
            </Snackbar>
            <Snackbar open={groupNotificationDontExistError} autoHideDuration={4000} onClose={() => setGroupNotificationDontExistError(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="warning">A group notification must exist to create a supervision</Alert>
            </Snackbar>
            <Snackbar open={noDeviceInMissionError} autoHideDuration={4000} onClose={() => setNoDeviceInMissionError(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="warning">A device must be added in this mission to create a supervision</Alert>
            </Snackbar>
            <Snackbar open={addSupervisionOpen} autoHideDuration={4000} onClose={() => setAddSupervisionOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="success">Mission supervision successfully added</Alert>
            </Snackbar>
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                aria-labelledby="alert-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: '#d0cfd0'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Are you sure to " + messagePopupDialog + " this mission ?"}
                </DialogTitle>
                <DialogActions>
                    <button className="userDialogButton" onClick={() => setDialogOpen(false)}>No</button>
                    <button className="userDialogButton" onClick={manageStateMission}>Yes</button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={addGroupOpen}
                onClose={() => setAddGroupOpen(false)}
                aria-labelledby="alert-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: '#d0cfd0'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Add new group in the mission"}
                </DialogTitle>
                <Formik
                    initialValues={addGroupMissionInitialValues}
                    validationSchema={addGroupMissionValidationSchema}
                    onSubmit={addGroupMission}
                >
                    {() => {
                        return(
                            <Form>
                                <FormikControl control="select" label="Group: " name="groupUser" options={groupUsersSelect}/>
                                <FormikControl control="select" label="Type of authorization: " name="typeAuthorization" options={selectTypeAuthorization}/>
                                <DialogActions>
                                    <button className="userDialogButton" type="button" onClick={() => setAddGroupOpen(false)}>Cancel</button>
                                    <button className="userDialogButton" type="submit">Add</button>
                                </DialogActions>
                            </Form>
                        )
                    }}
                </Formik>
            </Dialog>
            <Dialog
                open={addDeviceOpen}
                onClose={() => setAddDeviceOpen(false)}
                aria-labelledby="alert-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: '#d0cfd0'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Add new device in the mission"}
                </DialogTitle>
                <Formik
                    initialValues={addGroupDeviceMissionInitialValues}
                    validationSchema={addGroupDeviceMissionValidationSchema}
                    onSubmit={addGroupDeviceMission}
                >
                    {() => {
                        return(
                            <Form>
                                <FormikControl control="radio" label="What do you want to add ?" name="dialogRadioValue" options={dialogRadioOptions} onChangeAction={setDeviceChoiceRadio}/>
                                {deviceChoiceRadio === "groupDevice" ?
                                    <FormikControl control="select" label="Group of device: " name="idGroupDevice" options={groupDeviceSelect}/>
                                    :
                                    <FormikControl control="select" label="Device: " name="idDevice" options={selectDeviceToSelect(devicesSelect)}/>
                                }
                                <DialogActions>
                                    <button className="userDialogButton" type="button" onClick={handleCancelAddGroupDevice}>Cancel</button>
                                    <button className="userDialogButton" type="submit">Add</button>
                                </DialogActions>
                            </Form>
                        )
                    }}
                </Formik>
            </Dialog>
            <Dialog
                open={addKineticOpen}
                onClose={() => setAddKineticOpen(false)}
                aria-labelledby="alert-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: '#d0cfd0'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Add kinetics to the mission"}
                </DialogTitle>
                <Formik
                    initialValues={addKineticInitialValues}
                    validationSchema={addKineticValidationSchema}
                    onSubmit={addKineticMission}
                >
                    {() => {
                        return(
                            <Form>
                                <FormikControl control="select" label="Kinetics: " name="kinetic" options={kineticsSelect}/>
                                <FormikControl control="textarea" label="Description: " name="description" />
                                <FormikControl control="input" type="number" label="Alpha aging 1: " name="alphaAeging1"/>
                                <DialogActions>
                                    <button className="userDialogButton" type="button" onClick={() => setAddKineticOpen(false)}>Cancel</button>
                                    <button className="userDialogButton" type="submit">Add</button>
                                </DialogActions>
                            </Form>
                        )
                    }}
                </Formik>
            </Dialog>
        </div>
    )
}

export default ManageMissions;